import * as Yup from 'yup';

const schema = Yup.object({
  sum: Yup.string().required()
});

export default schema;
